import { render, staticRenderFns } from "./user-message-icon.vue?vue&type=template&id=25543a2c&scoped=true&"
import script from "./user-message-icon.vue?vue&type=script&lang=js&"
export * from "./user-message-icon.vue?vue&type=script&lang=js&"
import style0 from "./user-message-icon.vue?vue&type=style&index=0&id=25543a2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25543a2c",
  null
  
)

export default component.exports